module.exports = __webpack_public_path__ + "static/img/Avatar01.9e86611.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Avatar01.png
// module id = Ypxv
// module chunks = 1